const KEY = "finlo_demo_visitor";
const WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
};

export function markDemoVisit() {
  const v = read() || { id: (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, "") };
  v.last = Date.now();
  localStorage.setItem(KEY, JSON.stringify(v));
  return v.id;
}

export function recentDemoVisitorId() {
  const v = read();
  return v && Date.now() - v.last <= WINDOW_MS ? v.id : null;
}
